import { EyeOff } from 'lucide-react'
import type { LocalChatNote } from '../types'
import { AttachmentList } from 'src/shared/components/GlobalChatWidget/components/AttachmentList'
import { SafeMessageContent } from 'src/shared/components/GlobalChatWidget/components/SafeMessageContent'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import dayjs from 'dayjs'
import { OnlyVisibleToYouBadge } from './OnlyVisibleToYouBadge'

export const RequestLocalChatNote = ({
  note,
  isPreview = false,
}: {
  note: LocalChatNote
  isPreview?: boolean
}) => {
  const { t } = useLocalization()

  return (
    <Row className="gap-3 px-3 py-1.5">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-dashed border-stone-300/80 bg-stone-50 text-stone-500">
        <EyeOff className="h-3.5 w-3.5" aria-hidden />
      </div>

      <Column className="min-w-0 flex-1 gap-1">
        <Row className="flex-wrap items-center gap-x-2 gap-y-1">
          <span className="text-sm font-semibold text-foreground">
            {t('You', 'Du')}
          </span>
          <OnlyVisibleToYouBadge
            label={
              isPreview ? t('Example', 'Exempel') : undefined
            }
          />
          <span className="text-xs text-muted-foreground">
            {dayjs(note.createdAt).format('h:mm A')}
          </span>
        </Row>

        <div className="rounded-xl border border-dashed border-stone-200 bg-stone-50/70 px-3 py-2">
          {note.content?.trim() ? (
            <SafeMessageContent
              content={note.content}
              className="text-sm leading-relaxed text-foreground [&_p]:m-0"
            />
          ) : null}
          {(note.attachmentUrls?.length ?? 0) > 0 && (
            <AttachmentList
              urls={note.attachmentUrls ?? []}
              className={
                note.content?.trim() ? 'mt-2 flex-wrap gap-2' : 'flex-wrap gap-2'
              }
              linkClassName="block"
            />
          )}
        </div>

        {!isPreview && (
          <p className="text-[11px] leading-snug text-muted-foreground">
            {t(
              'Ping the team when you want them to see this.',
              'Pinga teamet när du vill att de ska se det här.'
            )}
          </p>
        )}
      </Column>
    </Row>
  )
}
